import { Divider, Flex, Spacing } from '@approvalmax/ui/src/components';
import { Fragment, memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { ReportTableSkeletonProps } from './ReportTable.types';

const rows = [1, 2, 3, 4];

export const ReportTableSkeleton = memo<ReportTableSkeletonProps>((props) => {
    const { spacing } = props;

    return (
        <>
            {spacing && spacing > 0 && <Spacing height={spacing} />}

            {rows.map((row) => (
                <Fragment key={row}>
                    {row > 1 && <Divider orientation='horizontal' spacing='8 0' />}

                    <Flex container>
                        <Flex size={6}>
                            <Skeleton width='100%' height={20} />
                        </Flex>

                        <Flex size={3}>
                            <Skeleton width='100%' height={20} />
                        </Flex>

                        <Flex size={4}>
                            <Skeleton width='100%' height={20} />
                        </Flex>

                        <Flex size={4}>
                            <Skeleton width='100%' height={20} />
                        </Flex>

                        <Flex size={3}>
                            <Skeleton width='100%' height={20} />
                        </Flex>

                        <Flex size={4}>
                            <Skeleton width='100%' height={20} />
                        </Flex>
                    </Flex>
                </Fragment>
            ))}

            {spacing && spacing > 0 && <Spacing height={spacing} />}
        </>
    );
});
